import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import triggerAnalyticsEvent, { Analytics } from '../../../../helpers/analyticsMiddleware';
import { shallowEqual, useSelector } from 'react-redux';
import LowBalanceDisputeCaseConfirmation from './LowBalanceDisputeCaseConfirmation';
import DisputeCaseConfirmation from './DisputeCaseConfirmation';
export var getPageSubFunction = function (isRedispute, lowBalanceDisputeApplied) {
    if (isRedispute) {
        return Analytics.Redispute;
    }
    if (lowBalanceDisputeApplied) {
        return Analytics.Documents;
    }
    return Analytics.Form;
};
var End = function () {
    var _a = useSelector(function (state) { return state; }, shallowEqual), lowBalanceDisputeApplied = _a.caseDetails.lowBalanceDisputeApplied, isRedispute = _a.questionnaire.isRedispute;
    useEffect(function () {
        var pageSubFunction = getPageSubFunction(isRedispute, lowBalanceDisputeApplied);
        triggerAnalyticsEvent({
            pageKind: Analytics.Dispute,
            pageFunction: Analytics.Billing,
            pageSubFunction: pageSubFunction,
            pageName: Analytics.Complete
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return lowBalanceDisputeApplied ? (_jsx(LowBalanceDisputeCaseConfirmation, {})) : (_jsx(DisputeCaseConfirmation, {}));
};
export default End;
//# sourceMappingURL=index.js.map